import React from "react";
import { Layout, Row, Col, message,
    // Card,
    // Drawer,
    Icon,
    Collapse,
    Steps
} from "antd";
// import cx from "classnames";
import BusinessProgramDetailsForm from "forms/add-business-program-details-form";
import BuyerQualificationDetailsForm from "forms/buyer-qualification-details-form";
import BusinessCashbackDetailsForm from "forms/business-cashback-details-form";
import BusinessProgramRecourseDetailsForm from "forms/business-program-recourse-details-form";
// import BusinessFacilityProductLineDetailsForm from "forms/business-facility-product-line-details-form";
import BusinessFacilityDetailsForm from "forms/business-facility-details-form";
import BussinessProgramFeeForm from "forms/business-program-fee-form";
import BuyerInterestDetailsForm from "forms/buyer-interest-details-form";
import BusinessAgreementDetailsForm from "forms/business-agreement-form";
import PropTypes from "prop-types";
import { SchemesService } from "services";
import { BusinessProgramDetailPipeline } from "utilities";
// import { STATE_STATUS } from "constants/index";
import { 
    fetchBusinessProgramDetail, 
    fetchBusinessProgramList,
    createBusinessProgram,
    updateBusinessProgram,
    createBuyerQualificationDetails,
    updateBuyerQualificationDetails,
    createBusinessProgramInterest,
    updateBusinessProgramInterest,
    fetchCompanyBusinessProgramDetail
} from "store/actions/index";
import BusinessAttachmentsDetailsForm from "forms/business-attachment-form";
import BusinessBasicDetailsForm from "forms/business-basic-detail-form";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { BUSINESS_PROGRAM_STAGES } from "constants/actions";
import { OrderedMap, List } from "immutable";
const { Step } = Steps;
const { Panel } = Collapse;

const {
    BUSINESS_PROGRAM,
    BASIC_DETAIL,
    FACILITY_DETAILS,
    // QUALIFICATION_DETAILS,
    // INTEREST_DETAILS,
    // FEE_DETAILS,
    // RECOUSE_DETAILS,
    // CASHBACK_DETAILS,
    ATTACHMENT_DETAILS,
    AGREEMENT_DETAILS
} = BUSINESS_PROGRAM_STAGES;

const STEPS_ARRAY = new List([
    BUSINESS_PROGRAM,
    BASIC_DETAIL,
    FACILITY_DETAILS,
    // QUALIFICATION_DETAILS,
    // INTEREST_DETAILS,
    // FEE_DETAILS,
    // RECOUSE_DETAILS,
    // CASHBACK_DETAILS,
    ATTACHMENT_DETAILS,
    AGREEMENT_DETAILS
]);

const steps = jump => new OrderedMap ({
    BUSINESS_PROGRAM: {
        id: BUSINESS_PROGRAM,
        title: (
            <a href={"javascript:void"} onClick={jump.bind(null, BUSINESS_PROGRAM)}>
                Business Program
            </a>
        )
    },
    BASIC_DETAIL: {
        id: BASIC_DETAIL,
        title: (
            <a href={"javascript:void"} onClick={jump.bind(null, BASIC_DETAIL)}>
                Basic Details
            </a>
        )
    },
    FACILITY_DETAILS: {
        id: FACILITY_DETAILS,
        title: (
            <a href={"javascript:void"} onClick={jump.bind(null, FACILITY_DETAILS)}>
                Facility Details
            </a>
        )
    },
    // QUALIFICATION_DETAILS: {
    //     id: QUALIFICATION_DETAILS,
    //     title: (
    //         <a href={"javascript:void"} onClick={jump.bind(null, QUALIFICATION_DETAILS)}>
    //             Buyer Qualification Details
    //         </a>
    //     )
    // },
    // INTEREST_DETAILS: {
    //     id: INTEREST_DETAILS,
    //     title: (
    //         <a href={"javascript:void"} onClick={jump.bind(null, INTEREST_DETAILS)}>
    //             Interest Details
    //         </a>
    //     )
    // },
    // FEE_DETAILS: {
    //     id: FEE_DETAILS,
    //     title: (
    //         <a href={"javascript:void"} onClick={jump.bind(null, FEE_DETAILS)}>
    //             Fee Details
    //         </a>
    //     )
    // },
    // RECOUSE_DETAILS: {
    //     id: RECOUSE_DETAILS,
    //     title: (
    //         <a href={"javascript:void"} onClick={jump.bind(null, RECOUSE_DETAILS)}>
    //             Recourse Details
    //         </a>
    //     )
    // },
    // CASHBACK_DETAILS: {
    //     id: CASHBACK_DETAILS,
    //     title: (
    //         <a href={"javascript:void"} onClick={jump.bind(null, CASHBACK_DETAILS)}>
    //             Cashback Details
    //         </a>
    //     )
    // },
    ATTACHMENT_DETAILS: {
        id: ATTACHMENT_DETAILS,
        title: (
            <a href={"javascript:void"} onClick={jump.bind(null, ATTACHMENT_DETAILS)}>
                Attachments
            </a>
        )
    },
    AGREEMENT_DETAILS: {
        id: AGREEMENT_DETAILS,
        title: (
            <a href={"javascript:void"} onClick={jump.bind(null, AGREEMENT_DETAILS)}>
                Agreement Details
            </a>
        )
    }
});

const customPanelStyle = {
    background: "#f7f7f7",
    borderRadius: 4,
    marginBottom: 24,
    border: 0,
    overflow: "hidden"
};

class SchemesDrawerView extends React.Component {
    state = {
        isSchemeDrawerVisible: false,
        parentProgram: null,
        parentProgramId: null,
        isParentProgramFetched: false,
        business_products: null,
        stepsKey: "1",
        collapseStep: "1",
        openAllDrawers: false,
        current: this.props.currentStage || "BUSINESS_PROGRAM"
    };
    componentDidMount() {
        if(this.props.companyId) {
            this.props.fetchCompanyBusinessProgramDetail(this.props.companyId);
        }
        // if(this.props.businessProgramId) {
        //     this.props.fetchBusinessProgramDetail(this.props.businessProgramId);
        // }
        SchemesService.getBusinessProductList().then(({data, error}) => {
            if(!error) {
                this.setState({
                    business_products: data.results
                });
            }
        });
        this.setState({
            isSchemeDrawerVisible: true,
        }); 
    }

    componentDidUpdate() {
        if(!this.state.isParentProgramFetched && this.state.parentProgramId) {
            this.getParentProgramDetails(this.state.parentProgramId);
        }
    }

    saveProgramDetails = (values) => {
        this.props.createBusinessProgram(this.props.companyId, values);
        if (values.parent_program) {
            this.props.fetchBusinessProgramDetail(values.parent_program);
            this.setState({
                parentProgramId: values.parent_program
            });
        }
    }

    saveBuyerQualificationDetails = (values) => {
        this.props.createBuyerQualificationDetails(values);
    }

    updateBuyerQualificationDetails = (values) => {
        this.props.updateBuyerQualificationDetails(this.props.qualificationId, values);
    }

    saveInterestDetails = (values) => {
        this.props.createBusinessProgramInterest(values, this.props.businessProgramId);
    }

    saveFeeDetails = (values) => {
        SchemesService.createBusinessProgramFee(values, this.props.businessProgramId).then(({error}) => {
            if(!error) {
                message.success("Fee Details Saved");
                
            } else {
                message.error("Failed to Save Fee Details");
            }
        });
    }

    saveFacilityDetails = (values) => {
        SchemesService.createBusinessProgramFacilityDetails(values, this.props.businessProgramId).then(({error}) => {
            if(!error) {
                message.success("Facility Details Saved");
                
            } else {
                message.success("Failed to Save Facility Details");
            }
        });
    }

    createRecourseDetails = (values) => {
        SchemesService.createBusinessProgramRecourseDetails(values).then(({error}) => {
            if(!error) {
                message.success("Recourse Details Saved");
                
            } else {
                message.error("Failed to Save Recourse Details");
            }
        });
    }

    saveCashbackDetails = (values) => {
        SchemesService.createBusinessProgramCashBack(values).then(({error}) => {
            if(!error) {
                message.success("Cashback Details Saved");
                
            } else {
                message.error("Failed to Save Cashback Details");
            }
        });
    }

    saveAttachments = (values) => {
        let data = new FormData();
        data.append("buyer_finance_agreements", values.buyer_finance_agreements);
        values.credit_note && data.append("credit_note", values.credit_note);
        values.name_clearance && data.append("name_clearance", values.name_clearance);
        data.append("guarantor_agreement", values.guarantor_agreement);
        data.append("business_program", values.business_program);
        SchemesService.createBusinessAttachments(data).then(({error}) => {
            if(!error) {
                message.success("Attachment Details Saved");
                
            } else {
                message.error("Failed to Save Attachments");
            }
        });
    }

    saveAgreementDetails = (values) => {
        SchemesService.createBusinessAgreementDetails(values).then(({error}) => {
            if(!error) {
                message.success("Agreement Details Saved");
                
            } else {
                message.error("Failed to Save Agreement Details");
            }
        });
    }

    updateAgreementDetails = (values) => {
        SchemesService.updateBusinessAgreementDetails(this.props.agreementId, values).then(({error}) => {
            if(!error) {
                message.success("Agreement Details Updated");
                
            } else {
                message.error("Failed to Update Agreement Details");
            }
        });
    }

    updateRecourseDetails = (values) => {
        SchemesService.updateBusinessProgramRecourseDetails(this.props.recourseId, values).then(({error}) => {
            if(!error) {
                message.success("Recourse Details Updated");
                
            } else {
                message.error("Failed to Update Recourse Details");
            }
        });
    }

    updateCashbackDetails = (values) => {
        SchemesService.updateBusinessProgramCashBack(this.props.cashbackDetailId, values).then(({error}) => {
            if(!error) {
                message.success("Cashback Details Updated");
                
            } else {
                message.error("Failed to Update Cashback Details");
            }
        });
    }

    updateBusinessProgram = (values) => {
        this.props.updateBusinessProgram(this.props.businessProgramId, values);
    }

    updateAttachmentDetails = (values) => {
        let data = new FormData();
        values.buyer_finance_agreements && typeof values.buyer_finance_agreements === "object" && data.append("buyer_finance_agreements", values.buyer_finance_agreements);
        values.credit_note && typeof values.credit_note === "object" && data.append("credit_note", values.credit_note);
        values.name_clearance && typeof values.name_clearance === "object" && data.append("name_clearance", values.name_clearance);
        values.guarantor_agreement && typeof values.guarantor_agreement === "object" && data.append("guarantor_agreement", values.guarantor_agreement);
        // data.append("business_program", values.business_program);
        SchemesService.updateBusinessAttachementDetails(this.props.attachmentId, data).then(({error}) => {
            if(!error) {
                message.success("Attachments Updated");
                
            } else {
                message.error("Failed to Update Attachments");
            }
        });
    }

    getParentProgramDetails = id => {
        SchemesService.getBusinessProgram(id).then(({data,error}) => {
            if(!error) {
                this.setState({
                    parentProgram: BusinessProgramDetailPipeline.run(data),
                    isParentProgramFetched: true
                });
            }
        });
    }

    saveBasicDetails = (values) => {
        SchemesService.createBasicDetails(values).then(({error}) => {
            if(!error) {
                message.success("Basic Details Saved");
                
            } else {
                message.error("Failed to Save Basic Details");
            }
        });
    }

    updateBasicDetails = (values) => {
        SchemesService.updateBasicDetails(this.props.basicDetailId, values).then(({error}) => {
            if(!error) {
                message.success("Basic Details Updated");
                
            } else {
                message.error("Failed to Update Basic Details");
            }
        });
    }

    deleteFacilityDetails = (id) => {
        SchemesService.deleteFacilityDetails(id);
    }

    deleteFeeDetails = (id) => {
        SchemesService.deleteFeeDetails(id);
    }

    deleteInterestDetails = id => {
        SchemesService.deleteInterestDetails(id);
    }

    jump = stageName => {
        this.setState({
            current: stageName
        });
    };
    steps = steps(this.jump);

    renderForms = () => {
        const { businessProgramId } = this.props;
        switch(this.state.current) {
        case BUSINESS_PROGRAM:
            return (
                <BusinessProgramDetailsForm
                    values={(this.props.programDetailData && this.props.programDetailData.businessProgramDetails) }
                    saveProgramDetails={this.saveProgramDetails}
                    updateBusinessProgram={this.updateBusinessProgram}
                    business_products={this.state.business_products}
                    getParentProgramDetails={this.getParentProgramDetails}
                />
            );
        case BASIC_DETAIL:
            return (
                <BusinessBasicDetailsForm 
                    values={this.props.programDetailData && this.props.programDetailData.basicDetails}
                    parentProgramData={(this.state.parentProgram && this.state.parentProgram.basicDetails)}
                    saveBasicDetails={this.saveBasicDetails}
                    businessProgramId={businessProgramId}
                    updateBasicDetails={this.updateBasicDetails}
                />
            );
        case FACILITY_DETAILS:
            return (
                <Collapse defaultAcKey={"1"} onChange={(key) => this.setState({
                    collapseStep: key
                })}
                bordered={false}
                activeKey={this.state.collapseStep}
                expandIcon={({ isActive }) => <Icon type="caret-right" rotate={isActive ? 90 : 0} />}
                >
                    <Panel key={"1"} header={"Facility Details"} style={customPanelStyle}>
                        <BusinessFacilityDetailsForm 
                            values={this.props.programDetailData && this.props.programDetailData.businessFacilityDetails}
                            parentProgramData={(this.state.parentProgram && this.state.parentProgram.businessFacilityDetails)}
                            saveFacilityDetails={this.saveFacilityDetails}
                            businessProgramId={businessProgramId}
                        />
                    </Panel>
                    <Panel key={"2"} header={"Qualification Details"} style={customPanelStyle}>
                        <BuyerQualificationDetailsForm 
                            values={this.props.programDetailData && this.props.programDetailData.buyerQualificationDetails}
                            parentProgramData={(this.state.parentProgram && this.state.parentProgram.buyerQualificationDetails)}
                            saveBuyerQualificationDetails={this.saveBuyerQualificationDetails}
                            businessProgramId={businessProgramId}
                            updateBuyerQualificationDetails={this.updateBuyerQualificationDetails}
                        />
                    </Panel>
                    <Panel key={"3"} header={"Fee Details"} style={customPanelStyle}>
                        <BussinessProgramFeeForm 
                            values={this.props.programDetailData && this.props.programDetailData.businessProgramFee}
                            parentProgramData={(this.state.parentProgram && this.state.parentProgram.businessProgramFee)}
                            saveFeeDetails={this.saveFeeDetails}
                            businessProgramId={businessProgramId}
                        />
                    </Panel>
                    <Panel key={"4"} header={"Interest Details"} style={customPanelStyle}>
                        <BuyerInterestDetailsForm 
                            values={this.props.programDetailData && this.props.programDetailData.businessInterestDetails}
                            parentProgramData={(this.state.parentProgram && this.state.parentProgram.businessInterestDetails)}
                            saveInterestDetails={this.saveInterestDetails}
                            businessProgramId={businessProgramId}
                        />
                    </Panel>
                    <Panel key={"5"} header={"Recourse Details"} style={customPanelStyle}>
                        <BusinessProgramRecourseDetailsForm 
                            values={this.props.programDetailData && this.props.programDetailData.businessProgramRecourseDetails}
                            parentProgramData={(this.state.parentProgram && this.state.parentProgram.businessProgramRecourseDetails)}
                            createRecourseDetails={this.createRecourseDetails}
                            updateRecourseDetails={this.updateRecourseDetails}
                            businessProgramId={businessProgramId}
                        />
                    </Panel>
                    <Panel key={"6"} header={"Cashback Details"} style={customPanelStyle}>
                        <BusinessCashbackDetailsForm 
                            values={this.props.programDetailData && this.props.programDetailData.businessProgramCashbackDetails}
                            parentProgramData={(this.state.parentProgram && this.state.parentProgram.businessProgramCashbackDetails)}
                            saveCashbackDetails={this.saveCashbackDetails}
                            businessProgramId={businessProgramId}
                            updateCashbackDetails={this.updateCashbackDetails}
                        />
                    </Panel>
                </Collapse>
                
            );
            // case QUALIFICATION_DETAILS:
            //     return (
                    
            //     );
            // case INTEREST_DETAILS:
            //     return (
                    
            //     );
            // case FEE_DETAILS:
            //     return (
                    
            //     );
            // case RECOUSE_DETAILS:
            //     return (
                    
            //     );
            // case CASHBACK_DETAILS:
            //     return (
                    
            //     );
        case ATTACHMENT_DETAILS:
            return (
                <BusinessAttachmentsDetailsForm 
                    values={this.props.programDetailData && this.props.programDetailData.businessAttachments}
                    saveAttachments={this.saveAttachments}
                    businessProgramId={businessProgramId}
                    updateAttachmentDetails={this.updateAttachmentDetails}
                />
            );
        case AGREEMENT_DETAILS:
            return (
                <BusinessAgreementDetailsForm 
                    values={this.props.programDetailData && this.props.programDetailData.businessAgreementDetails}
                    saveAgreementDetails={this.saveAgreementDetails}
                    updateAgreementDetails={this.updateAgreementDetails}
                    businessProgramId={businessProgramId}
                />
            );
            
        default:
            return null;
        }
    }

    render() {
        const {
            state: { current }
        } = this;
        return (
            <Row>
                <Col span={24}>
                    <Layout
                        style={{ height: "100vh", overflow: "scroll" }}
                    >
                        <Row>
                            <Col className={"p-5"}>
                                <Steps
                                    size={"small"}
                                    labelPlacement={"vertical"}
                                    current={STEPS_ARRAY.findIndex(_ => _ === current)}
                                >
                                    {this.steps.map(_ => (
                                        <Step
                                            key={_.id}
                                            title={_.title}
                                        />
                                    )).toList().toArray()}
                                </Steps>
                                
                            </Col>
                            <Col className={"p-5"}>
                                {this.renderForms()}
                            </Col>
                        </Row>
                    </Layout>
                </Col>
            </Row>
        );
    }
}
SchemesDrawerView.propTypes = {
    history: PropTypes.object,
    location: PropTypes.object,
    businessProgramDetailStatus: PropTypes.string,
    businessProgramId: PropTypes.string || PropTypes.number,
    programDetailData: PropTypes.object,
    fetchBusinessProgramDetail: PropTypes.func,
    fetchBusinessProgramList: PropTypes.func,
    attachmentId: PropTypes.number,
    qualificationId: PropTypes.number,
    recourseId: PropTypes.number,
    agreementId: PropTypes.number,
    cashbackDetailId: PropTypes.number,
    basicDetailId: PropTypes.number,
    parent_program_id: PropTypes.number,
    parentProgramData: PropTypes.object,
    currentStage: PropTypes.string,
    status: PropTypes.string,
    errors: PropTypes.string,
    stagesComplete: PropTypes.object,
    companyId: PropTypes.string,
    createBusinessProgram: PropTypes.func,
    updateBusinessProgram: PropTypes.func,
    createBuyerQualificationDetails: PropTypes.func,
    updateBuyerQualificationDetails: PropTypes.func,
    createBusinessProgramInterest: PropTypes.func,
    schemes: PropTypes.object,
    fetchCompanyBusinessProgramDetail: PropTypes.func
};

const mapStateToProps = (state, props) => {
    let id = props.companyId;
    let parent_program_id = state.schemes.getIn(["business_program_detail", id, "data", "parent_program", "id"]);
    return {
        businessPrograms: state.schemes,
        businessProgramId: state.schemes.getIn(["business_program_detail", id, "data", "id"]),
        parent_program_id: parent_program_id,
        businessProgramDetailStatus: state.schemes.getIn(["business_program_detail", id, "status"]),
        programDetailData: state.schemes.getIn(["business_program_detail", id, "data"]),
        parentProgramData: parent_program_id ? state.schemes.getIn(["business_program_detail", parent_program_id, "data"]) : null,
        attachmentId: state.schemes.getIn(["business_program_detail", id, "data", "business_program_attachments", "id"]),
        cashbackDetailId: state.schemes.getIn(["business_program_detail", id, "data", "business_program_cashback", "id"]),
        agreementId: state.schemes.getIn(["business_program_detail", id, "data", "business_program_agreement_details", "id"]),
        qualificationId: state.schemes.getIn(["business_program_detail", id, "data", "business_program_buyer_qualification_detail", "id"]),
        basicDetailId: state.schemes.getIn(["business_program_detail", id, "data", "business_program_basic_details", "id"]),
        recourseId: state.schemes.getIn(["business_program_detail", id, "data", "business_program_recourse_detail", "id"])
    };
};

// const mapStateToProps = (state, { match: { params } }) => {
//     // console.log(props);
//     // let parent_program_id = state.schemes.getIn(["business_program_detail", props.id, "data", "parent_program", "id"]);
//     let parent_program_id = state.schemes.getIn(["business_program_detail", params.id, "data", "parent_program", "id"]);
//     return {
//         businessPrograms: state.schemes,
//         businessProgramId: params.id,
//         parent_program_id: parent_program_id,
//         businessProgramDetailStatus: state.schemes.getIn(["business_program_detail", params.id, "status"]),
//         programDetailData: state.schemes.getIn(["business_program_detail", params.id, "data"]),
//         parentProgramData: parent_program_id ? state.schemes.getIn(["business_program_detail", parent_program_id, "data"]) : null,
//         attachmentId: state.schemes.getIn(["business_program_detail", params.id, "data", "business_program_attachments", "id"]),
//         cashbackDetailId: state.schemes.getIn(["business_program_detail", params.id, "data", "business_program_cashback", "id"]),
//         agreementId: state.schemes.getIn(["business_program_detail", params.id, "data", "business_program_agreement_details", "id"]),
//         qualificationId: state.schemes.getIn(["business_program_detail", params.id, "data", "business_program_buyer_qualification_detail", "id"]),
//         basicDetailId: state.schemes.getIn(["business_program_detail", params.id, "data", "business_program_basic_details", "id"]),
//         recourseId: state.schemes.getIn(["business_program_detail", params.id, "data", "business_program_recourse_detail", "id"])
//     };
// };

const mapDispatchToProps = dispatch =>
    bindActionCreators(
        {
            fetchBusinessProgramDetail,
            fetchBusinessProgramList,
            createBusinessProgram,
            updateBusinessProgram,
            createBuyerQualificationDetails,
            updateBuyerQualificationDetails,
            createBusinessProgramInterest,
            updateBusinessProgramInterest,
            fetchCompanyBusinessProgramDetail,
        },
        dispatch
    );

export default connect(mapStateToProps, mapDispatchToProps) (SchemesDrawerView);